function toLogin() {
  debugger;
  if (window.appConfig.USE_UIC) {
    const id = window.location.pathname.split('/')[1];
    window.location.href = `${window.appConfig.UIC_URL}#/login?redirectUrl=${window.location.href}&tenantId=${id}`;
  } else {
    window.location.href = `/login?redirectUrl=${window.location.pathname}`; // 用路由跳转
  }
}
function checkStatus(response: Response) {
  if (response.status === 200) {
    return response.json();
  } else if (response.status === 401) {
    alert('未登录或登录已过期，请重新登录。');
    toLogin();
    return;
  } else if (response.status === 426) {
    alert('license已到期');
    window.location.href = `/active`;
    return;
  } else if (response.status === 404) {
    alert('接口未找到');
    return;
  } else if (response.status === 504) {
    alert('接口超时');
    return;
  } else if (response.status === 418) {
    // 未登陆
    response.text().then((url) => {
      const state = Math.random().toString(36).substring(2, 8);
      const redirectUrl = window.location.href;
      const exp = Date.now() + 10 * 60 * 1000;
      localStorage.setItem(
        state,
        JSON.stringify({
          redirectUrl,
          exp
        })
      );
      window.location.href = url + `&state=${state}`;
    });
  } else {
    console.error(response);
    return Promise.reject({ message: '网络错误或服务器异常，请稍后再试' });
  }
}

interface EResponse {
  success: boolean;
  code: number;
  data: any;
}
function handleSuccess(response: EResponse) {
  if (response) {
    if (response.success) {
      return Promise.resolve(response.data);
      // } else if (response.code === -1) {
      //   // 大屏分享需要密码
      //   return Promise.resolve(-1);
    } else {
      return Promise.reject(response);
    }
  }
}

function handleError(error: Error, hideError: boolean = true) {
  if (error && error.name === 'AbortError') {
    return;
  } else {
    if (!hideError) {
      console.error(error.message);
    }
    if ('Failed to fetch' === error.message) {
      toLogin();
    }
    return;
  }
}

interface requestProps {
  url: string;
  data?: { [key: string]: any };
  option?: {
    signal?: AbortSignal;
    hideError?: boolean;
    formdata?: boolean;
  };
}

function httpGet({ url, data = {}, option }: requestProps) {
  let { signal, hideError } = option || {};
  let queryString = Object.entries(data).reduce((all, item) => {
    const content = typeof item[1] === 'object' && item[1] !== null ? JSON.stringify(item[1]) : item[1];
    all.push(`${item[0]}=${content}`);
    return all;
  }, [] as string[]);

  url = /^https?:\/\//.test(url) ? url : window.appConfig.API_URL + url;
  url = queryString.length ? (url += '?' + queryString.join('&')) : url;

  return fetch(url, {
    method: 'GET',
    credentials: 'include',
    signal
  })
    .then(checkStatus)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error, hideError));
}

function httpPost({ url, data = {}, option }: requestProps) {
  let { signal, hideError, formdata = false } = option || {};

  url = /^https?:\/\//.test(url) ? url : window.appConfig.API_URL + url;

  let struc: any = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'content-type': 'application/json'
    },
    body: JSON.stringify(data),
    signal
  };

  if (formdata) {
    delete struc.headers;
    // struc.headers['content-type'] = 'application/x-www-form-urlencoded';
    var formData = new FormData();
    Object.keys(data).map((key) => {
      formData.append(key, data[key]);
    });
    struc.body = formData;
  }

  return fetch(url, struc)
    .then(checkStatus)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error, hideError));
}

// spaceship/:id/8nejyoOl_1583409709475_B7ZZ5GyR4.png
function renamePath(name: string) {
  let extname = name.slice(name.lastIndexOf('.'));
  const newname = Math.random().toString(36).substr(2);
  return +new Date() + '_' + newname + extname;
}

export { httpGet as get, httpPost as post };
